import { render, staticRenderFns } from "./BookingTimeConfig.vue?vue&type=template&id=622ec89e&scoped=true"
import script from "./BookingTimeConfig.vue?vue&type=script&lang=js"
export * from "./BookingTimeConfig.vue?vue&type=script&lang=js"
import style0 from "./BookingTimeConfig.vue?vue&type=style&index=0&id=622ec89e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ec89e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('622ec89e')) {
      api.createRecord('622ec89e', component.options)
    } else {
      api.reload('622ec89e', component.options)
    }
    module.hot.accept("./BookingTimeConfig.vue?vue&type=template&id=622ec89e&scoped=true", function () {
      api.rerender('622ec89e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/BookingTimeConfig.vue"
export default component.exports